
import {Component, Prop, Vue} from 'vue-property-decorator'

import {countryByISO} from '@/checkout/utils/countries'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const defaultLogo = require(process.env.VUE_APP_DEFAULT_LOGO_PATH)

const FLAG_CDN_BASE_URL = 'https://flagcdn.com/w80'
const FLAG_IMAGE_FORMAT = 'jpg'

interface CountryInfo {
  name: string
  flag: string
}

@Component
export default class CheckoutHeader extends Vue {
  @Prop({ default: defaultLogo }) readonly logo!: string
  @Prop({ default: 'BR' }) readonly country!: string

  appBrand = process.env.VUE_APP_NAME.split('-')[0]

  get countryInfo(): CountryInfo | undefined {
    const country = countryByISO(this.country)

    if (!country) {
      return undefined
    }

    return {
      name: country.name,
      flag: `${FLAG_CDN_BASE_URL}/${country.iso.toLowerCase()}.${FLAG_IMAGE_FORMAT}`,
    }
  }

  get logoAltText(): string {
    return 'Company logo'
  }

  get countryFlagAltText(): string {
    return this.countryInfo ? `${this.countryInfo.name} flag` : 'Country flag'
  }

  get countryAriaLabel(): string {
    return this.countryInfo ? `Country: ${this.countryInfo.name}` : 'Country information'
  }
}
